import useLiquidityPositionSvg from '@/presentation/hooks/useLiquidityPositionSvg';
import LazyImage from '../LazyImage/LazyImage';
import { Address, TokenId } from 'nftx.js';

const LiquiditySvg = ({
  tokenId,
  manager,
  alt,
  className,
}: {
  manager: Address;
  tokenId: TokenId;
  className?: string;
  alt?: string;
}) => {
  const svg = useLiquidityPositionSvg({ manager, tokenId });

  return <LazyImage src={svg} alt={alt} className={className} />;
};

export default LiquiditySvg;
